import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Icon, Menu, MenuItem, Tooltip } from '@mui/material';
import AppIcon from '../appIcon';
// Actions
import { openAppsConsole, openAppsEdit } from '../../redux/slice';
import './styles.scss';

/**
 * Name cell of the Apps grid: the design's dropdown with the integration options. "Edit integration" opens the
 * edit side panel of any app; apps that sync vehicles add "Linked vehicles" (locked while a sync started here runs).
 */
const IntegrationMenu = ({ intl: { messages }, integration, syncing }) => {
    const dispatch = useDispatch();
    const [anchor, setAnchor] = useState(null);

    const options = [{
        key: 'edit',
        icon: 'edit',
        label: messages['accountAppsMenu_edit'],
        sub: null,
        disabled: false,
        onClick: () => dispatch(openAppsEdit(integration.id))
    }];
    if (integration.syncsVehicles) {
        options.push({
            key: 'vehicles',
            icon: 'local_shipping',
            label: messages['accountAppsMenu_linkedVehicles'],
            sub: syncing ? messages['accountAppsMenu_linkedVehiclesLocked'] : null,
            disabled: syncing,
            onClick: () => dispatch(openAppsConsole(integration.id))
        });
    }

    const close = () => setAnchor(null);
    return (
        <>
            <Tooltip title={messages['accountAppsMenu_options']} placement="top">
                <button
                    type="button"
                    className="account-apps-name-button"
                    aria-haspopup="menu"
                    aria-expanded={!!anchor}
                    onClick={(e) => setAnchor(e.currentTarget)}
                >
                    <AppIcon className="account-apps-icon" icon={integration.icon} color={integration.color} name={integration.integrationName} />
                    <span className="account-apps-name-label">{integration.integrationName}</span>
                    <Icon className="account-apps-name-arrow">arrow_drop_down</Icon>
                </button>
            </Tooltip>
            <Menu
                anchorEl={anchor}
                open={!!anchor}
                onClose={close}
                className="account-apps-menu"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.key}
                        className="account-apps-menu-item"
                        disabled={option.disabled}
                        onClick={() => { close(); option.onClick(); }}
                    >
                        <Icon className="account-apps-menu-icon">{option.icon}</Icon>
                        <span className="account-apps-menu-text">
                            {option.label}
                            {option.sub && <span className="account-apps-menu-sub">{option.sub}</span>}
                        </span>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default injectIntl(IntegrationMenu);
